var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconbuttontogglableStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.5L20.5 23.45L24.5 26.5L23 21.55L27 18.7H22.1L20.5 13.5L18.9 18.7H14L18 21.55L16.5 26.5ZM20.5 30.5C19.1167 30.5 17.8167 30.2375 16.6 29.7125C15.3833 29.1875 14.325 28.475 13.425 27.575C12.525 26.675 11.8125 25.6167 11.2875 24.4C10.7625 23.1833 10.5 21.8833 10.5 20.5C10.5 19.1167 10.7625 17.8167 11.2875 16.6C11.8125 15.3833 12.525 14.325 13.425 13.425C14.325 12.525 15.3833 11.8125 16.6 11.2875C17.8167 10.7625 19.1167 10.5 20.5 10.5C21.8833 10.5 23.1833 10.7625 24.4 11.2875C25.6167 11.8125 26.675 12.525 27.575 13.425C28.475 14.325 29.1875 15.3833 29.7125 16.6C30.2375 17.8167 30.5 19.1167 30.5 20.5C30.5 21.8833 30.2375 23.1833 29.7125 24.4C29.1875 25.6167 28.475 26.675 27.575 27.575C26.675 28.475 25.6167 29.1875 24.4 29.7125C23.1833 30.2375 21.8833 30.5 20.5 30.5ZM20.5 28.5C22.7333 28.5 24.625 27.725 26.175 26.175C27.725 24.625 28.5 22.7333 28.5 20.5C28.5 18.2667 27.725 16.375 26.175 14.825C24.625 13.275 22.7333 12.5 20.5 12.5C18.2667 12.5 16.375 13.275 14.825 14.825C13.275 16.375 12.5 18.2667 12.5 20.5C12.5 22.7333 13.275 24.625 14.825 26.175C16.375 27.725 18.2667 28.5 20.5 28.5Z",
    fill: "#FD5E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1650"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbuttontogglableStandard);
export default __webpack_public_path__ + "static/media/Icon button togglable - standard.e2894c6b3c61e7431f149127453055d3.svg";
export { ForwardRef as ReactComponent };